<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-form title="NÍVEIS DE ACESSO DO USUÁRIO" :rota="{name: 'usuarioRead'}" tooltip="Lista de Usuários" />

            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                        <md-tabs class="md-info mdTabs">
                            <md-tab v-if="permissoes.usuarioRemoveNiveisAcesso" id="tab-niveis" md-label="Níveis de Acesso" md-icon="security">
                                <div class="md-layout" style="padding-top: 60px; margin-bottom: -30px;">
                                    <div class="md-layout-item md-size-75 md-xsmall-size-100" style="margin-top: -20px;">
                                        <h4 class="uppercase text-secondary"><strong>{{ usuario.nome }}</strong></h4>
                                    </div>
                                    <div class="md-layout-item md-size-25 md-xsmall-size-100" style="margin-top: -20px;">
                                        <md-button @click="removePermissoes" class="md-danger md-round md-block">
                                            <span class="md-label">
                                                <md-icon class="material-icons">delete</md-icon>
                                            </span>EXCLUIR
                                        </md-button>
                                    </div>
                                </div>
                                <md-table v-model="searched" md-card @md-selected="selectDelete" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 60%" md-sort-by="descricao">{{ item.descricao }}</md-table-cell>
                                    </md-table-row>
                                </md-table>                                
                            </md-tab>

                            <md-tab v-if="permissoes.usuarioAddNiveisAcesso" id="tab-add-niveis" md-label="Adicionar Níveis de Acesso" md-icon="add">
                                <div class="md-layout" style="padding-top: 60px; margin-bottom: -30px;">
                                    <div class="md-layout-item md-size-75 md-xsmall-size-100" style="margin-top: -20px;">
                                        <h4 class="uppercase text-secondary"><strong>{{ usuario.nome }}</strong></h4>
                                    </div>
                                    <div class="md-layout-item md-size-25 md-xsmall-size-100" style="margin-top: -20px;">
                                        <md-button @click="adicionarPermissoes" class="md-success md-round md-block">
                                            <span class="md-label">
                                                <md-icon class="material-icons">add</md-icon>
                                            </span>ADICIONAR
                                        </md-button>
                                    </div>
                                </div>
                                <md-table v-model="searchedNiveis" md-card @md-selected="selectAdd" md-fixed-header>
                                    <md-table-toolbar>
                                        <div class="md-toolbar-section-start"></div>
                                        <md-field md-clearable class="md-toolbar-section-end">
                                            <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTableNiveis" />
                                        </md-field>
                                    </md-table-toolbar>

                                    <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select class="tableRow">
                                        <md-table-cell md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 60%" md-sort-by="descricao">{{ item.descricao }}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </md-tab>
                        </md-tabs>
                    </div>
                </div>
            </md-card-content>

        </md-card>
    </div>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import preLoader from '@/config/mixins/preLoader';
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

const toLower = text => {
    return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower([item.nome, item.descricao]).includes(toLower(term)))
    }

    return items
}

export default {
    name: 'UsuarioReadNiveisAcesso',
    components: {
        HeaderForm
    },

    mixins: [Notify, preLoader],

    data() {
        return {
            dados: {},
            usuario: {},
            permissoes: this.$store.state.usuario.permissao,
            usuarioNiveisAcesso: [],
            niveisAcesso: [],
            deleteNiveisAcesso: [],
            addNiveisAcesso: [],
            search: null,
            searched: [],
            searchedNiveis: [],
            buscar: {
                busca: ''
            }
        };
    },

    created() {
        this.getNiveisAcesso()
        this.searched = this.usuarioNiveisAcesso
        this.searchedNiveis = this.niveisAcesso
    },

    methods: {
        getNiveisAcesso() {
            this.$http.get(this.$urlAPI + 'usuarios/niveis_acesso/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioNiveisAcesso = response.data.dados;
                        this.niveisAcesso = response.data.niveis;
                        this.searched = response.data.dados
                        this.searchedNiveis = response.data.niveis
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        searchOnTable() {
            this.searched = searchByName(this.usuarioNiveisAcesso, this.search)
        },

        searchOnTableNiveis() {
            this.searchedNiveis = searchByName(this.niveisAcesso, this.search)
        },

        selectDelete(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.deleteNiveisAcesso = item
        },

        selectAdd(items) {
            let item = []
            items.forEach(element => {
                item.push(element.id)
            });
            this.addNiveisAcesso = item
        },

        removePermissoes() {
            if (this.deleteNiveisAcesso.length === 0) {
                return this.warning('Selecione pelo menos uma Permissão antes de excluir!')
            }
            this.dados.id = this.usuario.id
            this.dados.niveis = this.deleteNiveisAcesso
            this.$http.post(this.$urlAPI + 'usuarios/remove_niveis_acesso', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioNiveisAcesso = response.data.dados;
                        this.niveisAcesso = response.data.niveis;
                        this.searched = response.data.dados
                        this.searchedNiveis = response.data.niveis
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        adicionarPermissoes() {
            if (this.addNiveisAcesso.length === 0) {
                return this.warning('Selecione pelo menos um Nível de Acesso antes de adicionar!')
            }
            this.dados.id = this.usuario.id
            this.dados.niveis = this.addNiveisAcesso
            this.$http.post(this.$urlAPI + 'usuarios/niveis_acesso', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.usuario;
                        this.usuarioNiveisAcesso = response.data.dados;
                        this.niveisAcesso = response.data.niveis;
                        this.searched = response.data.dados
                        this.searchedNiveis = response.data.niveis
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.md-tab {
    margin-top: -50px !important;
}

.mdTabs {
    margin-top: 30px;
}
</style>
